import { useEffect, useState } from "react";
import api from "../../lib/api";
import { currency, fmtDate } from "../../lib/status";

export default function AdminCustomers() {
    const [customers, setCustomers] = useState([]);
    useEffect(() => {
        api.get("/customers").then(({ data }) => setCustomers(data));
    }, []);

    return (
        <div className="space-y-6">
            <div>
                <div className="lx-label text-[#D4AF37] mb-2">CRM</div>
                <h1 className="font-serif text-4xl text-white">Customers</h1>
            </div>
            <div className="lx-card-dark overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="text-left text-white/60 border-b border-[#2B1438]">
                        <tr>
                            <th className="p-4 lx-label">Name</th>
                            <th className="p-4 lx-label">Email</th>
                            <th className="p-4 lx-label">Phone</th>
                            <th className="p-4 lx-label text-right">Wallet</th>
                            <th className="p-4 lx-label">Joined</th>
                        </tr>
                    </thead>
                    <tbody>
                        {customers.map((c) => (
                            <tr
                                key={c.id}
                                className="border-b border-[#2B1438]"
                                data-testid={`cust-row-${c.id}`}
                            >
                                <td className="p-4 text-white">{c.name}</td>
                                <td className="p-4 text-white/80">{c.email}</td>
                                <td className="p-4 text-white/60">{c.phone || "—"}</td>
                                <td className="p-4 text-right font-serif text-[#D4AF37]">
                                    {currency(c.wallet_balance, "AED")}
                                </td>
                                <td className="p-4 text-white/60">{fmtDate(c.created_at)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {customers.length === 0 && (
                    <div className="p-12 text-center text-white/60">No customers.</div>
                )}
            </div>
        </div>
    );
}
